
<template>
  <span>
    <span v-if="player.name == '*'"><v-icon small left style="padding-bottom:0.2em;">mdi-guy-fawkes-mask</v-icon>{{$t('common.wildcard')}}</span>
    <span v-else-if="isDeletedPlayer"><i>{{$t('common.deleted-player')}}</i></span>
    <pre v-else-if="showIdOfPlatform && getOnlineIdOfPlatform(showIdOfPlatform)" class="online-id">{{displayedName}}<verified-sign v-if="player.verified"/></pre>
    <span v-else>{{displayedName}}<verified-sign v-if="player.verified"/></span>
  </span>
</template>

<script>
import VerifiedSign from "@/widgets/VerifiedSign";

export default {
  name: "PlayerName",
  components: {VerifiedSign},
  props: {
    player: {
      type: Object,
      required: true
    },
    showIdOfPlatform: {
      type: String,
      default: undefined
    }
  },
  computed: {
    isDeletedPlayer: function() {
      return this.player.name && this.player.name.indexOf('$deleted$') === 0
    },
    displayedName: function() {
      if (this.showIdOfPlatform) {
        let onlineId = this.getOnlineIdOfPlatform(this.showIdOfPlatform)
        return onlineId ? onlineId : this.player.name
      }
      return this.player.name
    },
  },
  methods: {
    getOnlineIdOfPlatform(platformCode) {
      let onlineId = this.player.onlineIds[platformCode]
      return onlineId ? onlineId.onlineId : undefined
    }
  }
};
</script>
<style scoped>
.online-id {
  display: inline;
  word-break: break-all;
  white-space: normal;
}
</style>
